import { API_URL } from '../api/api1';

export const getImageUrl = imagePath => {
  if (!imagePath) return null;
  if (imagePath.startsWith('blob:') || imagePath.startsWith('data:')) return imagePath;

  const cleanPath = imagePath.split('?')[0];
  const normalizedPath = cleanPath.startsWith('/') ? cleanPath.slice(1) : cleanPath;
  return `${API_URL}/${normalizedPath}`;
};

export const getImageUrlWithTimestamp = (imagePath, forceRefresh = true) => {
  const imageUrl = getImageUrl(imagePath);
  if (!imageUrl) return null;

  const timestamp = forceRefresh ? Date.now() : Math.floor(Date.now() / 60000);
  const random = Math.random().toString(36).substring(7);
  return `${imageUrl}?t=${timestamp}&r=${random}`;
};

export const fileToBase64 = file => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });
};

export const compressImage = (file, maxWidth = 800, quality = 0.7) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = event => {
      const img = new Image();
      img.src = event.target.result;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        let width = img.width;
        let height = img.height;

        if (width > maxWidth) {
          height = (maxWidth / width) * height;
          width = maxWidth;
        }

        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);

        canvas.toBlob(
          blob => {
            if (!blob) {
              reject(new Error('Image compression failed'));
              return;
            }
            resolve(new File([blob], file.name, {
              type: 'image/jpeg',
              lastModified: Date.now(),
            }));
          },
          'image/jpeg',
          quality
        );
      };
      img.onerror = reject;
    };
    reader.onerror = reject;
  });
};
